import React from 'react';
import classNames from 'classnames';
import TipContext from '@home/components/TipContext';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getName } from '@home/utils/common';
import './index.scss';

export interface IViewportFullscreenTipProps {
  isFullScreen: boolean;
  requestFullScreen: () => void;
  exitFullScreen: () => void;
  className?: string;
  /**
   * 为 true 时灰置并禁止进入全屏；已全屏时仍可退出（避免加载中困在全屏态）。
   */
  disabled?: boolean;
}

/**
 * Dashboard 视口全屏入口：与 useViewportCssFullScreen 搭配使用，文案统一为 全屏 / Full Screen。
 *
 * 注意：组件内部会自带一层 wrapper div 承载 className，TipContext 走在 wrapper 内层。
 * 这样 className（通常是 dbd-operation-btn）所携带的 flex / gap 等布局样式不会污染
 * 到 TipContext 自身的 db-tipcontext-icon 节点，与 DownloadButton 的结构保持一致。
 */
const ViewportFullscreenTip: React.FC<IViewportFullscreenTipProps> = ({
  isFullScreen,
  requestFullScreen,
  exitFullScreen,
  className,
  disabled = false,
}) => {
  const { isEN } = useLocal();
  const isEnterDisabled = Boolean(disabled && !isFullScreen);

  const handleClick = (): void => {
    if (isEnterDisabled) {
      return;
    }
    if (isFullScreen) {
      exitFullScreen();
      return;
    }
    requestFullScreen();
  };

  return (
    <div
      className={classNames('dbd-viewport-fullscreen-tip', className, {
        'dbd-viewport-fullscreen-tip--disabled': isEnterDisabled,
      })}
    >
      <TipContext
        tipText={
          isFullScreen
            ? getName(isEN, 'Exit Full Screen', '退出全屏')
            : getName(isEN, 'Full Screen', '全屏')
        }
        type={{
          default: isFullScreen ? 'clonse' : 'fullscreen',
          hover: isFullScreen ? 'clonse' : 'fullscreen',
        }}
        onClick={handleClick}
      />
    </div>
  );
};

export default ViewportFullscreenTip;
